module.exports = __webpack_public_path__ + "static/img/y61.35fbc84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y61.jpg
// module id = iwXb
// module chunks = 1